import { createSlice } from "@reduxjs/toolkit";
import React from "react";

const initialState = {
    isCreateNewArticle: false,
};

const AdminReducer = createSlice({
    name: "AdminReducer",
    initialState: initialState,
    reducers: {
        createNewArticle: (state) => {
            return {
                ...state,
                isCreateNewArticle: true,
            };
        },
        closeNewArticle: (state) => {
            return {
                ...state,
                isCreateNewArticle: false,
            };
        },
    },
});
export default AdminReducer;
